/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function letProto(func) {
    return func(this);
}
//# sourceMappingURL=let.js.map 



//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/node_modules/rxjs/_esm5/operator/let.js
// module id = ../../../../rxjs/_esm5/operator/let.js
// module chunks = vendor